var devHelper = {
  devMode: false, // 用来控制是否开发模式
  // 判断是不是Dev模式            
  isDevMode: function () {
    return this.devMode
  },
  // 设置Dev模式            
  setDevMode(devMode) {
    this.devMode = devMode
  },
}
export default devHelper    
